import { FC, ReactNode } from 'react';
import { QueryClientProvider } from 'react-query';
import queryClient from './queryClient';

type Props = {
  children?: ReactNode;
};

const QueryProvider: FC<Props> = ({ children }) => (
  <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);

export default QueryProvider;
